import axios from "axios";
import { getSessionId } from "../../../../utils/tokenHandlers";
import UidEmailRoleMatch from "../../../constants/uidEmailRoleMatch";

export const getKeyPersonIds = async (
  customerId: number,
  personId: number | null
) => {
  const sessionid = getSessionId();
  const UidEmailRole = UidEmailRoleMatch();

  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/read/many/tradexwbench.customer_key_person/`,
      {
        params: {
          ...UidEmailRole,
          filter: `[('customer_id', 'in',  [${customerId}]), ('id', '=', [${personId}])]`,
          query: "{id, customer_id, customer_key_person_document_ids}",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionid}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
